import { useEffect, useState } from 'react';
import { ViewTicketContent } from './ViewTicketContent';
import { ViewTicketDetails } from './ViewTicketDetails';
import { TicketResponseBar } from './TicketResponseBar';
import { Receipt } from '@material-ui/icons';
import { SupportTicket, SupportTicketUpdate } from '../../../types/commonTypes';
import { NoDataMessage } from '../../../components/NoDataMessage';
import { xsScreen } from '../../../lib/constants';
import { useMediaQuery } from '../../../hooks/useMediaQuery';
import Modal from '../../../components/Modal';

interface Props {
  ticketData?: SupportTicket | null;
  onClose(close: boolean): void;
  open: boolean;
  updateSubmitted: boolean;
  setUpdateSubmitted(bool: boolean): void;
}

export const ViewTicketModal = ({
  ticketData,
  onClose,
  open,
  updateSubmitted,
  setUpdateSubmitted,
}: Props) => {
  const [ticketMessages, setTicketMessages] = useState<SupportTicketUpdate[]>(
    []
  );
  const isMobile = useMediaQuery(xsScreen);

  useEffect(() => {
    if (ticketData && !updateSubmitted) {
      setTicketMessages(ticketData.updates);
    }
  }, [open, ticketData, updateSubmitted]);

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Modal
      id="ticket-modal"
      header={ticketData ? ticketData.subject : 'No Ticket Data'}
      headerIcon={<Receipt />}
      onClose={handleClose}
      open={open}
      maxWidth="md"
    >
      {ticketData ? (
        <>
          <ViewTicketDetails isMobile={isMobile} ticketData={ticketData} />
          <ViewTicketContent
            ticketId={ticketData.id}
            ticketMessages={ticketMessages}
          />
          <TicketResponseBar
            key={ticketData.id}
            ticketInfo={ticketData}
            setUpdateSubmitted={setUpdateSubmitted}
          />
        </>
      ) : (
        <div className="w-full h-[200px]">
          <NoDataMessage
            title="Unable to Load Ticket Information"
            subTitle="Try again later"
          />
        </div>
      )}
    </Modal>
  );
};
